module.exports = {"title":"Бизнес-лаборатория","description":"Киберпреступления обходятся мировой экономике в $600 млрд ежегодно. Вероятность столкновения с киберугрозами для организаций ретейла в России близка к 100%. Инвестиции в информационную безопасность позволят избежать этих рисков","image":"https://businesslab.gazeta.ru/img/kasperskiy_share.png","url":"https://businesslab.gazeta.ru/","fbappid":396959934055666,"GTM":"GTM-NGQCDZL"}


//////////////////
// WEBPACK FOOTER
// ./js/meta.json
// module id = 361
// module chunks = 0